exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fiat-currency-list .Select-control {\n  border-radius: 3px;\n  border: 3px solid #fff;\n  height: 42px;\n}\n\n.fiat-currency-list .Select-value-label {\n  font-size: 16px;\n  color: #111;\n}\n\n.Select-placeholder, .Select--single > .Select-control .Select-value {\n  height: 32px;\n  padding-left: 4px;\n}\n\n.Select-arrow-zone {\n  position: absolute;\n  right: 0;\n  width: 16px;\n  top: -4px;\n}\n", ""]);

// exports
